import axios from 'axios'
import { BSAE_API_URL } from '../config'

export const HttpRequestAxios = axios.create({
  baseURL: BSAE_API_URL,
  timeout: 20000,
})
